import type { TFunction } from 'i18next';

import { eodLogForGrid } from '../../../pok/components/EOD/EODLogSearch';
import { TKeys } from '../../hooks/useTranslation';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { DefaultApi } from '../autogenerated/pokApiClient';

export interface EodLogsContextInterface {
  getAllByPortion: (
    t: TFunction<'fvzLng', 'fvzLng'>,
    tk: TKeys<'fvzLng'>,
    refresh: boolean,
    setRefresh: (refresh: boolean) => void,
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  changeStatusExportedToEod: (eodId: number) => Promise<number>;
}

export const EodLogsContext = (api: DefaultApi) => {
  return {
    getAllByPortion: async (
      t: TFunction<'fvzLng', 'fvzLng'>,
      tk: TKeys<'fvzLng'>,
      refresh: boolean,
      setRefresh: (refresh: boolean) => void,
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data = await api.eodLogControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns,
      );
      return data.map(item => eodLogForGrid(t, tk, item, refresh, setRefresh));
    },
    getAllCount: (filterText?: string, filterColumns?: string) =>
      api.eodLogControllerGetAllCount(filterText || '', filterColumns),
    changeStatusExportedToEod: (eodId: number) =>
      api.eodDocumentControllerChangeStatusExportedToEod(eodId),
  };
};
